module.exports = __webpack_public_path__ + "static/media/one.a50922c3.svg";